import { useState } from "react";

import FormVanSearchField, {
  VanSearchFieldValue
} from "src/components/form/FormVanSearchField";
import SubmitButton from "src/components/form/SubmitButton";
import { getCampaign_campaign } from "src/graphql/generated/getCampaign";
import { VanProxySearchType } from "src/graphql/generated/globalTypes";

export default function VanSavedListPicker({
  campaign,
  onSubmit
}: {
  campaign: getCampaign_campaign;
  onSubmit: (listId: number) => any;
}): JSX.Element {
  const [selectedList, setSelectedList] = useState<VanSearchFieldValue | null>(
    null
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    return onSubmit(selectedList!.id);
  };

  return (
    <>
      <FormVanSearchField
        fullWidth
        label="Pick a saved list"
        value={selectedList}
        onChange={(_event, value) => setSelectedList(value)}
        campaignId={campaign.id}
        searchType={VanProxySearchType.SAVED_LIST}
      />
      <div>
        <SubmitButton
          disabled={!selectedList}
          isSubmitting={isSubmitting}
          submitText="Import"
          loadingText="Starting import..."
          onClick={handleSubmit}
        />
      </div>
    </>
  );
}
